import React from 'react';

class ToggleErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    if (error.message && error.message.includes('toggle')) {
      return { hasError: true, error };
    }
    return null;
  }

  componentDidCatch(error, errorInfo) {
    // Log toggle-related errors
    if (error.message && error.message.includes('toggle')) {
      console.error('Toggle Error Boundary caught an error:', error, errorInfo);
      
      // You can also log the error to an error reporting service here
      // logErrorToService(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI for toggle errors
      return (
        <div className="alert alert-warning" role="alert">
          <h5>⚠️ Component Error</h5>
          <p>There was an issue with toggle functionality. Please refresh the page.</p>
          <button 
            className="btn btn-primary" 
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ToggleErrorBoundary; 